import { GoogleMapType } from '../enums/google-map-enum';
import { HybridGoogleMap } from './hybrid-google-map';
import { IGoogleMap } from 'src/app/core/models/google-map-models';
import { RoutePlannerDataModel } from '../../route-planner/models/route-model';
import { AAGoogleMapEvents, AAvoidTrafficEvents, AARoutePlannerEvents, GoogleMapOptionsEvents } from 'src/app/core/events/events';
import { GoogleMapOptionsModel } from './google-map-model';

export class RoutePlannerHybridGoogleMap extends HybridGoogleMap  {

    private showMenuOption = true;

    constructor(mapType: GoogleMapType) {
        super(mapType);
    }

    public initMap(routeDataModel: RoutePlannerDataModel) {
        this.routeDataModel = routeDataModel;

        // init
        this.directionsService = new google.maps.DirectionsService();
        this.directionsDisplay = new google.maps.DirectionsRenderer({
            suppressMarkers: true
        });

        this.directionsDisplay.setMap(this.googleMap);
        this.directionsDisplay.setPanel(document.getElementById('directions-panel'));

        // this.setRouteDirection();
        google.maps.controlStyle = 'azteca';
        this.setupControls(this.googleMap);
        this.addGoogleMapEvent(this.googleMap);

        this.updateMapEvent();
    }

    public resetMap(mapType?: GoogleMapType): void {
        if (this.validateThisMap(mapType)) {
            this.googleMapRouteService.removeRoutingDirectionPloygon();
            this.googleMapRouteService.clearDirectionMaker(this.routeDirectionMarker);
            this.routeDirectionMarker = [];
            // console.log('**** Reseting map', this.googleMap);
            if (this.googleMap) {
                this.googleMap.setZoom(this.mapConfig.zoomLevel);
                this.setMapToCenter(this.googleMap, this.mapConfig.defaultPos);
            }
        }
    }

    public updateMapEvent (mapType?: GoogleMapType) {
        if (this.validateThisMap(mapType)) {
            this.dispatch(AAGoogleMapEvents.INVALID_ROUTE, {error: false});

            this.googleMapRouteService.removeRoutingDirectionPloygon();
            super.setRouteDirection(null);
        }
    }

    public directionsServiceRequestHandler(response, status, exist?: boolean) {
        if (!exist) {
            this.googleMapCacheManager.validateDirectionRequest({request: this.gReqOptions, responce: response});
        }

        if (status === google.maps.GeocoderStatus.OK) {
            this.directionsDisplay.setMap(this.googleMap);
            // this.directionsDisplay.setDirections(response);

            const routes: any = this.sortRouteByDuration(response.routes);

            // Update the traffic flag in traffic component
            this.dispatch(AAvoidTrafficEvents.UPDATE_TRAFFIC, this.routeDataModel.OptionsData.AvoidTraffic);
            this.dispatch(AARoutePlannerEvents.UPDATE_SUMMARY, routes);

            const googleRoute = this.mapsWrapper
                .reformatGoogleRouteResponse(new Array (routes[this.routeDataModel.SummaryData.SelectedAltRoute]) );
            this.googleMapRouteService.renderAARoutePath(googleRoute);

            const bounds = new google.maps.LatLngBounds(
                new google.maps.LatLng(
                    googleRoute.routes[0].bounds.southwest.lat,
                    googleRoute.routes[0].bounds.southwest.lng
                ),
                new google.maps.LatLng(
                    googleRoute.routes[0].bounds.northeast.lat,
                    googleRoute.routes[0].bounds.northeast.lng
                )
            );

            setTimeout( () => {
                this.addRouteDirectionMarkers(true);
            }, 100);

            this.googleMap.fitBounds(bounds);

            // store from & to location only into localstore
            this.routePlannerLocalStore.saveLocationIntoLocalStore(
                [this.routeDataModel.FromLocation, this.routeDataModel.ToLocation] );

            this.dispatch(AAGoogleMapEvents.VALID_ROUTE, this.routeDataModel);

        } else if (status === google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
            //
        } else if (status === google.maps.GeocoderStatus.ZERO_RESULTS) {
            this.dispatch(AAGoogleMapEvents.INVALID_ROUTE, this.routeDataModel);
            return  {routeDataModel: this.routeDataModel, status: status};
        }
    }

    public invalidateCluster(): void {
        const googleMapOptions: GoogleMapOptionsModel = this.routeDataModel.googleMapOptions;
        const options: any = {googleMap: this.googleMap, options: googleMapOptions, reload: true};

        this.dispatch(GoogleMapOptionsEvents.TRAFFIC_ALERT_CHANGED, options);
        this.dispatch(GoogleMapOptionsEvents.CARPARK_CHANGED, options);
    }

    public setupControls = (googleMap: IGoogleMap) => {
        const mapOptionUI = document.getElementById('mapOptTrafficAlertCarPark');
        if (this.showMenuOption && mapOptionUI) {
          const centerControlDiv = document.createElement('div');
          mapOptionUI.style.display = 'block';
          centerControlDiv.appendChild(mapOptionUI);
          centerControlDiv['index'] = 1;
          googleMap.controls[google.maps.ControlPosition.TOP_RIGHT].push(
            centerControlDiv
          );
        } else {
          mapOptionUI.style.display = 'none';
        }
      }
}
